import React, { useEffect, useState, useCallback } from "react";
import ComboAbmArtArticulos_FabricablesEtapas from "../../Combos/ComboAbmArtArticulos_FabricablesEtapas"
import ComboAbmArtPresentaciones from "../../Combos/ComboAbmArtPresentaciones"
import ComboAbmArtTamanos from "../../Combos/ComboAbmArtTamanos"
import ComboAbmArtUnidadesMedida from "../../Combos/ComboAbmArtUnidadesMedida"
import ComboProFabricacionesEtapas from "../../Combos/ComboProFabricacionesEtapas"
import { NumberBox } from "devextreme-react";
import LVButtonAccion from "../../../Basicos/LVButtonAccion";
import ComboAbmEexProfesionales from "../../Combos/ComboAbmEexProfesionales";

function LV_ART_Articulos_SelectorSimple_FabricacionPorEtapas({ actualizarObjetoParaAgregar, ancho = "100%",
  tienePresentaciones = false, tieneTamanos = false, tieneUnidadesMedida = false }) {

  const [codigoArticulo, setCodigoArticulo] = useState("");
  const [idEtapa, setIdEtapa] = useState(0);
  const [codigoTamano, setCodigoTamano] = useState("");
  const [reloadTamanos, setReloadTamanos] = useState(false);
  const [codigoPresentacion, setCodigoPresentacion] = useState("");
  const [codigoUbicacionOrigen, setCodigoUbicacionOrigen] = useState("");
  const [codigoUbicacionDestino, setCodigoUbicacionDestino] = useState("");

  const [reloadArticulos, setReloadArticulos] = useState(false);
  const [reloadPresentaciones, setReloadPresentaciones] = useState(false);
  const [codigoUnidadMedida, setCodigoUnidadMedida] = useState("");
  const [reloadUnidadesMedida, setReloadUnidadesMedida] = useState(false);

  const objetoParaAgregar = {
    CodigoArticulo: codigoArticulo,
    CodigoCompania: localStorage.getItem("CodigoCompania"),
    CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
    CodigoPlanta: localStorage.getItem("CodigoPlanta"),
    CodigoPresentacion: codigoPresentacion,
    CodigoTamano: codigoTamano,
    CodigoUnidadMedida: codigoUnidadMedida,
    CodigoUbicacionOrigen: codigoUbicacionOrigen,
    CodigoUbicacionDestino: codigoUbicacionDestino
  }

  const handleActualizarUbicaciones = (ubicacionOrigen, ubicacionDestino) => {
    setCodigoUbicacionOrigen(ubicacionOrigen);
    setCodigoUbicacionDestino(ubicacionDestino);
  };

  const handleCodigoArticuloOnValueChanged = useCallback(({ component }) => {
    if (component && component != null && component.option != null) {
      const selectedItem = component.option('selectedItem');
      if (selectedItem) {
        setCodigoArticulo(selectedItem.CodigoArticulo)
      }
    } else {
      setCodigoArticulo("")
    }
  }, []);

  const handleIdEtapaOnValueChanged = useCallback(({ component }) => {
    setCodigoArticulo("")
    setCodigoPresentacion("")
    setCodigoTamano("")
    setCodigoUnidadMedida("")

    if (component && component != null && component.option != null) {
      const selectedItem = component.option('selectedItem');
      setIdEtapa(selectedItem.IdEtapa)
    } else {
      setIdEtapa(0)
    }
  }, []);

  const handleCodigoPresentacionOnValueChanged = useCallback(({ component }) => {
    if (component && component.option && typeof component.option === 'function') {
      const selectedItem = component.option('selectedItem');
      if (selectedItem && selectedItem.CodigoPresentacion) {
        setCodigoPresentacion(selectedItem.CodigoPresentacion)
      } else {
        setCodigoPresentacion("")
      }
    }
  }, []);

  const handleCodigoTamanoOnValueChanged = useCallback(({ component }) => {
    if (component && component.option && typeof component.option === 'function') {
      const selectedItem = component.option('selectedItem');
      if (selectedItem && selectedItem.CodigoTamano) {
        setCodigoTamano(selectedItem.CodigoTamano)
      } else {
        setCodigoTamano("")
      }
    }
  }, []);

  const handleCodigoUnidadMedidaOnValueChanged = useCallback(({ component }) => {
    if (component && component.option && typeof component.option === 'function') {
      const selectedItem = component.option('selectedItem');
      if (selectedItem && selectedItem.CodigoUnidadMedida) {
        setCodigoUnidadMedida(selectedItem.CodigoUnidadMedida)
      } else {
        setCodigoUnidadMedida("")
      }
    }
  }, []);

  useEffect(() => {
    if (!codigoPresentacion) return;
    if (!codigoTamano) return;
    if (!codigoUnidadMedida) return;
    if (!codigoArticulo) return;
    if (!codigoUbicacionOrigen) return;
    if (!codigoUbicacionDestino) return;

    const objeto = {
      CodigoArticulo: codigoArticulo,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
      CodigoPlanta: localStorage.getItem("CodigoPlanta"),
      CodigoPresentacion: codigoPresentacion,
      CodigoTamano: codigoTamano,
      CodigoUnidadMedida: codigoUnidadMedida,
      CodigoUbicacionOrigen: codigoUbicacionOrigen,
      CodigoUbicacionDestino: codigoUbicacionDestino
    };

    actualizarObjetoParaAgregar(objeto);
  }, [
    codigoArticulo,
    codigoPresentacion,
    codigoTamano,
    codigoUnidadMedida,
    codigoUbicacionOrigen,
    codigoUbicacionDestino
  ]);

  return (
    <div className="LV-GroupBox-div LV-FlexContainer" style={{ width: '100%' }}>
      <ComboProFabricacionesEtapas
        value={idEtapa}
        CampoDescripcion="Descripcion"
        ancho="200"
        onValueChanged={handleIdEtapaOnValueChanged} />
      <ComboAbmArtArticulos_FabricablesEtapas
        IdEtapa={idEtapa}
        DescripcionCompleta={true}
        reloadData={reloadArticulos}
        value={codigoArticulo}
        CampoDescripcion="CodigoDescripcion"
        ancho="500"
        actualizarUbicaciones={handleActualizarUbicaciones}
        onValueChanged={handleCodigoArticuloOnValueChanged} />
      <ComboAbmArtPresentaciones
        value={codigoPresentacion}
        CodigoArticulo={codigoArticulo}
        onValueChanged={handleCodigoPresentacionOnValueChanged}
        reloadData={reloadPresentaciones}
        ancho="300"
        visible={tienePresentaciones} />
      <ComboAbmArtTamanos
        value={codigoTamano}
        CodigoArticulo={codigoArticulo}
        onValueChanged={handleCodigoTamanoOnValueChanged}
        reloadData={reloadTamanos}
        ancho="300"
        visible={tieneTamanos} />
      <ComboAbmArtUnidadesMedida
        value={codigoUnidadMedida}
        CodigoArticulo={codigoArticulo}
        onValueChanged={handleCodigoUnidadMedidaOnValueChanged}
        reloadData={reloadUnidadesMedida}
        ancho="300"
        visible={tieneUnidadesMedida} />
    </div>
  );
}

export default LV_ART_Articulos_SelectorSimple_FabricacionPorEtapas